import React from 'react';
import PropTypes from 'prop-types';

import SectionTitle from '../SectionTitle/index';
import styles from './practiceContact.module.css';
import { GOOGLE_API_KEY } from '../../../../config';
import LocationFilter from './LocationFilter';

const PracticeContact = ({ practice, locationSelected }) =>
  practice.Address || practice.AffiliatedOrganisations.length > 1 ? (
    <div className={styles.container}>
      {practice.AffiliatedOrganisations.length > 1 ? (
        <div className={styles.firstRow}>
          <SectionTitle title="Our Locations" />
          <LocationFilter
            options={practice.AffiliatedOrganisations}
            onClick={location => locationSelected(location)}
            selectedOption={practice.AffiliatedOrganisations.find(
              location => location.Id === practice.Id,
            )}
          />
        </div>
      ) : (
        <SectionTitle title="Location" />
      )}
      {practice.Address && (
        <div>
          <div className={styles.address}>{practice.Address}</div>
          <div className={styles.map}>
            <iframe
              title="googlemaps"
              src={`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_API_KEY}&q=${practice.Address}`}
              className={styles.iframe}
            />
          </div>
        </div>
      )}
    </div>
  ) : null;

PracticeContact.propTypes = {
  practice: PropTypes.object,
};

export default PracticeContact;
